document.addEventListener('DOMContentLoaded', () => {
  // Flip card functionality
  const benefitsItems = document.querySelectorAll('.ds-benefits__item-front .circle-chevron');
  const backBenefitsItems = document.querySelectorAll('.ds-benefits__item-back .circle-chevron');
  const benefitsItemsWrapper = document.querySelectorAll('.ds-benefits__item-front');
  const backBenefitsItemsWrapper = document.querySelectorAll('.ds-benefits__item-back');

  benefitsItems.forEach(item => {
    item.addEventListener('click', (event) => {
      const frontElement = event.target.closest('.ds-benefits__item-front');
      const backElement = frontElement.nextElementSibling;

      if (frontElement && backElement && backElement.classList.contains('ds-benefits__item-back')) {
        backElement.style.visibility = 'visible';
        backElement.style.display = 'grid';
        
        // Kleine Verzögerung für bessere Browser-Rendering
        requestAnimationFrame(() => {
          frontElement.classList.add('flipped');
          backElement.classList.add('flipped');
          
          setTimeout(() => {
            frontElement.style.visibility = 'visible';
          }, 500);
          // Wenn ein Back-Element angezeigt wird, alle anderen Front-Elemente anzeigen
          setTimeout(() => {
            // Verwenden von requestAnimationFrame für flüssigere Animation
            requestAnimationFrame(() => {
              // Alle Front-Elemente anzeigen und flipped-Klasse entfernen, außer das aktuell geklickte
              benefitsItemsWrapper.forEach(item => {
                // Überprüfen, ob es nicht das aktuell geklickte Element ist
                if (item !== frontElement) {
                  item.style.visibility = 'visible';
                  item.style.display = 'grid';
                  // Kleine Verzögerung für bessere Animation
                  requestAnimationFrame(() => {
                    item.classList.remove('flipped');
                  });
                }
              });
              
              // Alle Back-Elemente ausblenden und flipped-Klasse entfernen, außer das aktuell angezeigte
              backBenefitsItemsWrapper.forEach(item => {
                // Überprüfen, ob es nicht das aktuell angezeigte Back-Element ist
                if (item !== backElement) {
                  // Zuerst flipped-Klasse entfernen für Animation
                  requestAnimationFrame(() => {
                    item.classList.remove('flipped');
                    
                    // Nach der Animation ausblenden
                    setTimeout(() => {
                      item.style.visibility = 'hidden';
                    }, 500);
                  });
                }
              });
            });
          }, 200); // Kürzere Wartezeit, da wir requestAnimationFrame verwenden
        });
      }
    });
  });

  backBenefitsItems.forEach(item => {
    item.addEventListener('click', (event) => {
      const backElement = event.target.closest('.ds-benefits__item-back');
      const frontElement = backElement.previousElementSibling;

      if (frontElement && backElement && frontElement.classList.contains('ds-benefits__item-front')) {
        frontElement.style.visibility = 'visible';
        frontElement.style.display = 'grid';
        
        requestAnimationFrame(() => {
          frontElement.classList.remove('flipped');
          backElement.classList.remove('flipped');
          
          setTimeout(() => {
            backElement.style.visibility = 'hidden';
          }, 500);
        });
      }
    });
  });

  // Category switching functionality
  const category1 = document.querySelector('.ds-benefits__category-1');
  const category2 = document.querySelector('.ds-benefits__category-2');
  const items1 = document.querySelector('.ds-benefits__items-1');
  const items2 = document.querySelector('.ds-benefits__items-2');

  if (category1 && category2 && items1 && items2) {
    category1.addEventListener('click', () => {
      category1.classList.add('active', 'button', 'button--md', 'button--primary');
      category2.classList.add('inactive');
      category2.classList.remove('active', 'button', 'button--md', 'button--primary');
      items1.classList.remove('hidden');
      items2.classList.add('hidden');
    });

    category2.addEventListener('click', () => {
      category2.classList.add('active', 'button', 'button--md', 'button--primary');
      category1.classList.add('inactive');
      category1.classList.remove('active', 'button', 'button--md', 'button--primary');
      items2.classList.remove('hidden');
      items1.classList.add('hidden');
      
    });
  }
});